<template>
  <div class="raman-query-container">
    <search :formModel="formModel" :formButton="formButton" :deviceModelBusiType="12"></search>
    <div class="raman-search-box">
      <el-button v-if="authMenu['010802']" size="small" type="primary" @click="addInfoHandler">
        {{ $t('new') }}
      </el-button>
    </div>

    <m-table
      i18n-path="ramanQuery"
      :loading="loading"
      :tableData="hisData"
      :tableColumn="tableColumn"
      :oprateMenu="oprateMenu"
      :pagiOption="pagiOption"
      :span-method="spanMethod"
      v-on:search="search"
    ></m-table>

    <el-dialog
      v-if="dislogVisable"
      :title="dialogTitle"
      :visible.sync="dislogVisable"
      :showClose="false"
      width="500px"
    >
      <el-form v-if="dislogVisable" ref="form" :rules="formRules" :model="dialogForm">
        <el-form-item :label="translateTo('化验时间')" label-width="150px" prop="laboratoryTime">
          <el-date-picker
            v-model="dialogForm.laboratoryTime"
            format="yyyy-MM-dd HH:mm"
            type="datetime"
            :placeholder="translateTo('时间提示')"
            style="width: 100%"
          ></el-date-picker>
        </el-form-item>

        <el-form-item :label="translateTo('化验项')" label-width="150px" prop="laboratoryItem">
          <el-input v-model="dialogForm.laboratoryItem"></el-input>
        </el-form-item>

        <el-form-item :label="translateTo('化验值')" label-width="150px" prop="laboratoryValue">
          <el-input
            v-model="dialogForm.laboratoryValue"
            @input="formatNum(dialogForm.laboratoryValue, 'laboratoryValue')"
            :placeholder="translateTo('化验值提示')"
          ></el-input>
        </el-form-item>

        <el-form-item :label="translateTo('备注')" label-width="150px" prop="remarks">
          <el-input
            type="textarea"
            :rows="4"
            :maxlength="250"
            v-model="dialogForm.remarks"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeFormDialogHandler">{{ $t('cancel') }}</el-button>
        <el-button type="primary" @click="dialogSureHandler">{{ $t('confirm') }}</el-button>
      </div>
    </el-dialog>

    <!-- 删除dialog -->
    <el-dialog
      v-if="deleteDialogVisable"
      :title="translateTo('提示')"
      :visible.sync="deleteDialogVisable"
      width="500px"
    >
      <span>{{ translateTo('删除内容') }}</span>

      <div slot="footer" class="dialog-footer">
        <el-button @click="deleteDialogVisable = false">{{ $t('cancel') }}</el-button>
        <el-button :loading="deleteLoad" type="primary" @click="sureDeleteHandler">
          {{ $t('confirm') }}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { merge } from 'lodash';
import {
  ramanQuertListServer,
  saveRamanInfoServer,
  deleteRamanInfoServer
} from '@/api/raman-query.js';
import { formatTimestamp, downFile, dayTime } from '@/utils/utils';
import { formatTime } from '@/utils/date.js';

import Search from '@/components/mTable/search';
import MTable from '@/components/mTable/m-table';

export default {
  name: 'checkList',
  props: {
    sn: String
  },
  components: { Search, MTable },
  data() {
    return {
      hisData: [],
      loading: true,
      // 用于清除页面状态 调用 $destroy
      formModel: {
        officeId: [],
        rangeDateVal: [dayTime().begin.getTime(), dayTime().end.getTime()]
      },
      pagiOption: {
        offset: 1,
        limit: 10,
        total: 0,
        pagiSize: [10, 15, 20, 30],
        layout: 'total, sizes, prev, pager, next, jumper'
      },
      tableColumn: [
        { label: '化验项', prop: 'laboratoryItem' },
        { label: '化验值', prop: 'laboratoryValue' },
        {
          label: '化验时间',
          prop: 'laboratoryTime',
          temp: scope => {
            return `<span>${formatTime(scope.row.laboratoryTime)}</span>`;
          }
        },
        {
          label: '备注',
          prop: 'remarks'
        }
      ],
      oprateMenu: {
        label: '操作',
        width: '259px',
        list: [
          {
            text: '编辑',
            access: () => {
              return this.authMenu['010803'];
            },
            event: (_index, data) => {
              this.dislogVisable = true;
              this.dialogType = 'edit';
              this.dialogTitle = this.translateTo('弹框编辑');
              this.dialogForm = data;
            }
          },
          {
            text: '删除',
            access: () => {
              return this.authMenu['010804'];
            },
            event: (_index, data) => {
              this.deleteId = data.id;
              this.deleteDialogVisable = true;
            }
          }
        ]
      },
      formButton: [
        {
          text: '查询',
          code: '010801',
          event: () => {
            this.pagiOption.offset = 1;
            this.search();
          }
        },
        {
          text: '导出',
          code: '010805',
          loading: false,
          event: this.hisExport
        }
      ],

      dislogVisable: false,
      dialogTitle: '',
      dialogForm: {
        laboratoryTime: '',
        laboratoryItem: '',
        laboratoryValue: '',
        remarks: ''
      },

      deleteDialogVisable: false,
      deleteLoad: false
    };
  },
  computed: {
    comParams() {
      const { formModel, pagiOption } = this;
      return merge(
        {
          beginTime: formModel.rangeDateVal && formModel.rangeDateVal[0],
          endTime: formModel.rangeDateVal && formModel.rangeDateVal[1],
          limit: pagiOption.limit,
          offset: pagiOption.offset
        },
        formModel
      );
    },

    formRules() {
      return {
        laboratoryTime: [
          {
            required: true,
            message: this.translateTo('时间提示'),
            trigger: 'blur'
          }
        ],
        laboratoryItem: [
          {
            required: true,
            message: this.translateTo('校验项'),
            trigger: 'blur'
          }
        ],
        laboratoryValue: [
          {
            required: true,
            message: this.translateTo('校验值'),
            trigger: 'blur'
          }
        ]
      };
    }
  },

  methods: {
    formatNum(val, key) {
      let temp = val.toString();
      temp = temp.replace(/。/g, '.');
      temp = temp.replace(/[^\d.]/g, ''); //清除"数字"和"."以外的字符
      temp = temp.replace(/^\./g, ''); //验证第一个字符是数字
      temp = temp.replace(/\.{2,}/g, ''); //只保留第一个, 清除多余的
      temp = temp.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.');
      temp = temp.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3'); //只能输入两个小数
      this.dialogForm[key] = temp;
    },
    formatTimestamp,
    search() {
      this.loading = true;
      ramanQuertListServer(this.comParams)
        .then(res => {
          this.hisData = res.data.list;
          this.pagiOption.total = res.data.total;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    spanMethod({ row, column }) {
      if (column.property !== 'typeName' && column.property !== 'materialName') {
        return row.spanMerge;
      }
    },
    hisExport(op) {
      op.loading = true;
      downFile({
        url: '/ramanDataCollection/exportData',
        method: 'post',
        data: this.comParams
      }).finally(() => {
        op.loading = false;
      });
    },
    resetSearch() {
      const newData = this.$options.data.call(this);
      this.hisData.splice(0);
      Object.assign(this.formModel, newData.formModel);
      Object.assign(this.pagiOption, newData.pagiOption);
    },
    addInfoHandler() {
      this.dialogTitle = this.translateTo('弹框添加');
      this.dislogVisable = true;
    },
    closeFormDialogHandler() {
      this.dislogVisable = false;
      this.resetDialogForm();
    },
    dialogSureHandler() {
      this.$refs.form.validate(valid => {
        if (valid) {
          let obj = {
            laboratoryItem: this.dialogForm.laboratoryItem,
            laboratoryValue: this.dialogForm.laboratoryValue,
            remarks: this.dialogForm.remarks,
            laboratoryTime: this.convertToTimeStamp(this.dialogForm.laboratoryTime)
          };
          if (this.dialogType === 'edit') {
            obj.id = this.dialogForm.id;
          }

          saveRamanInfoServer(obj).then(res => {
            if (res.code === 200) {
              this.$message.success('保存成功');
              this.dislogVisable = false;
              this.search();
              this.resetDialogForm();
            } else {
              this.$message.error(res.message);
            }
          });
        } else {
          this.$message.warning(this.translateTo('空提示'));
        }
      });
    },
    resetDialogForm() {
      this.dialogForm = {
        laboratoryTime: '',
        laboratoryItem: '',
        laboratoryValue: '',
        remarks: ''
      };
    },
    sureDeleteHandler() {
      this.deleteLoad = true;
      deleteRamanInfoServer({ id: this.deleteId })
        .then(res => {
          if (res.code === 200) {
            this.$message.success('删除成功');
            this.deleteDialogVisable = false;
            this.hisData.forEach((item, index) => {
              if (item.id === this.deleteId) {
                this.hisData.splice(index, 1);
              }
            });
            this.$forceUpdate();
          } else {
            this.$message.error(res.message);
          }
        })
        .finally(() => {
          this.deleteLoad = false;
        });
    },
    convertToTimeStamp(dateTimeString) {
      return new Date(dateTimeString).getTime();
    }
  },
  watch: {
    sn: {
      handler(n, o) {
        if (n !== o) this.resetSearch();
        this.search();
      },
      immediate: true
    }
  }
};
</script>

<style lang="scss">
.raman-query-container {
  box-sizing: border-box;
  position: relative;
  .raman-search-box {
    position: absolute;
    right: 10px;
    top: 0;
  }
}
</style>
